'use client'
import { ProductSlider } from '../ProductSlider'
import './styles.scss'

interface RelatedProductCardProps {
  product: {
    id: string
    name: string
    href: string
    image: string | null
    description: string
    width: number
    height: number
    alternativeText: string | null
    new?: boolean
  }
}

interface SliderRelatedProductsProps {
  products: RelatedProductCardProps['product'][]
}

export const SliderRelatedProducts = ({
  products,
}: SliderRelatedProductsProps) => {
  return (
    <div className="related-products-slider">
      <div className="title">
        <h2>Produtos Relacionados</h2>
      </div>
      <ProductSlider
        products={products}
        splideClassName="splide--flex"
        ariaLabel="related-products-slider"
      />
    </div>
  )
}
